import { Model } from './model';
import { ApPortal } from './ap_portal';
import { Transform, Type } from 'class-transformer';
import dayjs from 'dayjs';
import { TransformStringToDayJS } from './utils';

export enum ApPortalSessionStatus {
  PENDING = 'pending',
  RUNNING = 'running',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export class ApPortalSession extends Model {
  id: string;

  ap_portal_id: string;

  status: string;

  session_id?: string;

  output?: string;

  portal_operation_types?: string[];

  @TransformStringToDayJS()
  finished_at: dayjs.Dayjs;

  @Type(() => ApPortal)
  ap_portal: ApPortal | null;
}
